import { PropsWithChildren } from 'react'

export const NoContent = ({ children }: PropsWithChildren) => {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <p className="typo-body1 font-normal text-gray-400">{children}</p>
    </div>
  )
}
